export default __webpack_public_path__ + "static/media/vento.82750a06.png";